import {Component,Inject} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import {IPopupIgnoreFloatingButton} from "@share/component/popup/IPopupIgnoreFloatingButton";
import {Observable} from "rxjs";
import {Progression} from "@domain/progression/progression";

@Component({
    selector: 'please-wait-dialog',
    templateUrl: './please-wait-dialog.component.html'
})
export class PleaseWaitDialogComponent implements IPopupIgnoreFloatingButton{
    idPopupIgnoreFloatingButton: string = "PleaseWaitDialogComponent";

    /**
     * Constructeur
     */
    constructor(@Inject(MAT_DIALOG_DATA) public data: { title?: string,progression?: Observable<Progression> }) {
    }
}